export const keys = ['state', 'latitude', 'longitude']
export const LOCATION_URL = 'https://www.google.com/maps/search/?api=1&query='
export const wpBaseUrl = 'https://thriveworks.com'
